import type React from "react";
import { AppHeader } from "@bcc/components/app-header";
import { AppSidebar } from "@bcc/components/app-sidebar";
import { AppFooter } from "@bcc/components/app-footer";
import { setAppLayoutTestId } from "./app-layout.utils";

interface AppLayoutProps {
  children: React.ReactNode;
  testId?: string;
}

export function AppLayout({ children, testId }: AppLayoutProps) {
  return (
    <div
      data-testid={testId ?? setAppLayoutTestId("container")}
      className="relative min-h-screen"
    >
      <AppHeader />
      <div className="flex">
        <AppSidebar />
        <main
          data-testid={setAppLayoutTestId("main-content")}
          className="ml-[264px] flex-1"
        >
          <div className="min-h-[calc(100vh-72px-48px)] p-6">{children}</div>
          <AppFooter />
        </main>
      </div>
    </div>
  );
}
